import { Ribbon } from 'icons';
import { useTranslation } from 'react-i18next';

import { formatDate, formatDateAsUtc } from '@/utils/date';
import { getDueDateColor, getDueDateString } from '@/utils/dueDate';

import PlanCardIcon from '@/components/Cards/PlanCard/PlanCardComponents/PlanCardIcon';
import PlanCardTag from '@/components/Cards/PlanCard/PlanCardComponents/PlanCardTag';

interface BadgeProps {
  isComplete: boolean;
  completionDate?: string | null;
  selectedDueDate: number;
  showDate: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  isComplete,
  completionDate,
  selectedDueDate,
  showDate,
}) => {
  const { t } = useTranslation();

  if (isComplete) {
    return (
      <PlanCardIcon
        icon={<Ribbon className="size-8!" />}
        tooltip={
          <p className="text-variant-body2 text-grayscale-gray7 font-normal">
            {t('TrainingPlans.statusOptions.completed')}{' '}
            {completionDate ? formatDate(completionDate) : t('Generic.na')}
          </p>
        }
      />
    );
  }

  if (showDate && selectedDueDate && !isNaN(selectedDueDate)) {
    return (
      <PlanCardTag
        color={getDueDateColor(selectedDueDate)}
        text={getDueDateString(selectedDueDate)}
        tooltip={t('TrainingPlans.accountability.due.dueDate', {
          dueDate: formatDateAsUtc(selectedDueDate),
        })}
      />
    );
  }

  return null;
};

export default Badge;
